/**
 * `223025` — *When {status, columnId} changes to {something, statusColumnValue}*
 * (58 recipes / 58 automations, `specs/M6-A3-automation-catalog.md` §10).
 *
 * Fires on a `cell.changed` for the configured column when the new label index equals the
 * configured one **and** the previous index differs — a repeated write of the same index is
 * suppressed one layer down anyway (the registry's `isEqual` never emits it), but the predicate
 * states the rule explicitly so a trigger can never fire on a no-op.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { columnRefSchema, labelIndexOf, labelValueMatches, labelValueSchema } from '../values.js';
export const statusChangesToParams = z.object({
    columnId: columnRefSchema,
    statusColumnValue: labelValueSchema,
});
export const statusChangesToTrigger = defineTrigger({
    id: '223025',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When {status, columnId} changes to {something, statusColumnValue}',
    paramsSchema: statusChangesToParams,
    requiredColumnTypes: ['status'],
    subscribes: ['cell.changed'],
    references: (params) => [
        { kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid },
    ],
    matches(event, params) {
        if (event.payload.columnId !== params.columnId.columnId)
            return false;
        const next = labelIndexOf(event.payload.value);
        const previous = labelIndexOf(event.payload.previousValue);
        if (next === previous)
            return false;
        return labelValueMatches(params.statusColumnValue, next);
    },
    outputs(event) {
        return {
            itemId: event.itemId,
            boardId: event.boardId,
            columnId: event.payload.columnId,
            columnValue: labelIndexOf(event.payload.value),
            prevStatusValue: labelIndexOf(event.payload.previousValue),
        };
    },
});
//# sourceMappingURL=223025.js.map